/*
 * Copyright (c) 2020. American Express Company
 */

import BWDataService from './bw-data.service';
import { RuleModel } from 'src/types/rule.model';
import { map } from 'lodash';

export default class RuleService extends BWDataService {
    public static async createOrUpdateRule(rule: Partial<RuleModel>): Promise<void> {
        if (rule.id) {
            await this.updateRule(rule);
        } else {
            await this.postRule(rule);
        }
    }

    public static async createRule(ruleToBeCreated: Partial<RuleModel>): Promise<RuleModel> {
        return await this.postRule(ruleToBeCreated);
    }

    public static async createRules(rules: Array<Partial<RuleModel>>): Promise<RuleModel> {
        return await this.post(
            '/rules/batch-create',
            map(rules, (r: Partial<RuleModel>) => ({
                priority: r.priority,
                groupUid: r.groupUid,
                transactionName: r.transactionName,
                matcher: r.matcher
            }))
        );
    }

    private static async postRule(rule: Partial<RuleModel>): Promise<RuleModel> {
        return await this.post('/rules', {
            priority: rule.priority,
            groupUid: rule.groupUid,
            transactionName: rule.transactionName,
            matcher: rule.matcher
        });
    }

    public static async updateRule(rule: Partial<RuleModel>): Promise<RuleModel> {
        return await this.put(`/rules/${rule.id}`, {
            priority: rule.priority,
            groupUid: rule.groupUid,
            transactionName: rule.transactionName,
            matcher: rule.matcher
        });
    }

    public static async getRules(): Promise<RuleModel[]> {
        return await this.get('/rules');
    }

    public static async deleteRule(id: string): Promise<number> {
        return await this.delete('/rules/' + id);
    }
}
